import { _ } from "~/i18n";
import { node } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { AIRPLANE_VIEW_24, HIKE_MAP_24 } from "~/util/sds-compatible-icons";

type TLayer = "none" | "turist" | "ophoto";
type TOnChange = (layer: TLayer) => void;

/**
 * Ovladaci prvky do mapy v galerii
 */
function log(data) {
	Mapy.getComponent("logger").log("click", Object.assign(Mapy.getComponent("gallery").logData, data));
}

export default class ControlLayer {
	_onChange: TOnChange;

	_node: HTMLElement;

	_ophotoBtn: HTMLMapyToggleElement;

	_turistBtn: HTMLMapyToggleElement;

	constructor({
		onChange = () => {},
	}: {
		onChange: TOnChange;
	}) {
		this._onChange = onChange;
		this._node = node("mapy-map-button-group", { className: "gallery-mapsets" });
		this._ophotoBtn = node("mapy-map-toggle", { title: _("mapsetSwitch.ophoto"), innerHTML: `<span>${_("mapsetSwitch.ophoto")}</span>` });
		this._turistBtn = node("mapy-map-toggle", { title: _("gallery.map.control"), innerHTML: `<span>${_("gallery.map.control")}</span>` });

		this._ophotoBtn.prepend(createSDSIcon({ symbol: AIRPLANE_VIEW_24 }));
		this._turistBtn.prepend(createSDSIcon({ symbol: HIKE_MAP_24 }));

		this._ophotoBtn.setAttribute("data-log-ignore", "1");
		this._turistBtn.setAttribute("data-log-ignore", "1");

		this._build();
	}

	destroy() {
		this._ophotoBtn.removeEventListener("change", this, false);
		this._turistBtn.removeEventListener("change", this, false);
	}

	getContainer() {
		return this._node;
	}

	handleEvent(event) {
		if (event.target === this._turistBtn || this._turistBtn.contains(event.target)) {
			this._ophotoBtn.checked = false;

			log({
				text: this._turistBtn.checked ? "outdoorOpen" : "outdoorClose",
			});

			this._changeLayer(this._turistBtn.checked ? "turist" : "none");
		}

		if (event.target === this._ophotoBtn || this._ophotoBtn.contains(event.target)) {
			this._turistBtn.checked = false;

			log({
				text: this._ophotoBtn.checked ? "ophotoOpen" : "ophotoClose",
			});

			this._changeLayer(this._ophotoBtn.checked ? "ophoto" : "none");
		}
	}

	_build() {
		this._ophotoBtn.addEventListener("change", this, false);
		this._turistBtn.addEventListener("change", this, false);

		this._node.appendChild(this._ophotoBtn);
		this._node.appendChild(this._turistBtn);
	}

	_changeLayer(layer: TLayer) {
		this._onChange(layer);
	}
}
